import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "First Name",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter your first name."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Last Name",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter you last name."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Mobile Number",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Please enter a valid phone number.",
    "Please enter a valid phone number format."
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Secondary Phone Number",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "Please enter a valid phone number format."
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Address Line 1 (Street address, House Number etc)",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter your address."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Address Line 2 (Unit Number, Apartment, Suite, Floor etc)",
  "size": 100,
  "model": "address2"
},
{
  "id": "city",
  "type": "input",
  "label": "City",
  "size": 50,
  "model": "city"
},
{
  "id": "state",
  "type": "select",
  "label": "State / Province",
  "size": 50,
  "model": "state",
  "list": [
    { id: "AL", name:"AL" }, { id: "AR", name:"AR" }, { id: "AZ", name:"AZ" }, { id: "CA", name:"CA" }, { id: "CO", name:"CO" }, 
    { id: "CT", name:"CT" }, { id: "DE", name:"DE" }, { id: "DC", name:"DC" }, { id: "FL", name:"FL" }, { id: "GA", name:"GA" }, 
    { id: "ID", name:"ID" }, { id: "IL", name:"IL" }, { id: "IN", name:"IN" }, { id: "IA", name:"IA" }, { id: "KS", name:"KS" }, 
    { id: "KY", name:"KY" }, { id: "LA", name:"LA" }, { id: "ME", name:"ME" }, { id: "MD", name:"MD" }, { id: "MA", name:"MA" }, 
    { id: "MI", name:"MI" }, { id: "MN", name:"MN" }, { id: "MS", name:"MS" }, { id: "MO", name:"MO" }, { id: "MT", name:"MT" }, 
    { id: "NE", name:"NE" }, { id: "NV", name:"NV" }, { id: "NH", name:"NH" }, { id: "NJ", name:"NJ" }, { id: "NM", name:"NM" }, 
    { id: "NY", name:"NY" }, { id: "NC", name:"NC" }, { id: "ND", name:"ND" }, { id: "OH", name:"OH" }, { id: "OK", name:"OK" }, 
    { id: "OR", name:"OR" }, { id: "PA", name:"PA" }, { id: "RI", name:"RI" }, { id: "SC", name:"SC" }, { id: "SD", name:"SD" }, 
    { id: "TN", name:"TN" }, { id: "TX", name:"TX" }, { id: "UT", name:"UT" }, { id: "VT", name:"VT" }, { id: "VA", name:"VA" }, 
    { id: "WA", name:"WA" }, { id: "WV", name:"WV" }, { id: "WI", name:"WI" }, { id: "WY", name:"WY" }
  ],
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter state."
  ]
},
{
  "id": "postal-code",
  "type": "input",
  "label": "Zip / Postal Code",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter your postal code."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "Country/Region",
  "size": 50,
  "model": "countryName"
}
]